/*
 * @Date: 2021-09-18 11:33:23
 * @Author: manuelzhao
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-25 15:35:48
 * @Description: file content
 * @FilePath: /wemeet-web-activity/src/utils/beacon.ts
 */
import getBeacon from '../utils/async-module/get-beacon';
import { getUserInfoFromSession, UserData } from './login-util';
import { isMobile } from '@utils/ua/is-mobile';
import isServer from '@utils/env/is-server';
import { isWechat, isWeMeetApp } from '@tencent/web-base';
import cookies from 'next-cookies';

let cacheReportTask: { eventName: string; reportObj: Object }[] = [];
let beaconInstance: null | { onDirectUserAction: Function } = null;

export async function initBeacon(): Promise<void> {
  // 如果已经有了实例，则不需要再次配置
  if (beaconInstance) {
    return;
  }
  try {
    // 初始化
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { default: BeaconAction } = await getBeacon();
    beaconInstance = new BeaconAction({
      appkey: '00000C2AM539PVHX', // 系统或项目id, 必填
      // delay: 1000, // 上报延时
    });
  } catch (error) {
    console.log('initBeacon error --', error);
  }
  // 清空缓存的任务
  if (cacheReportTask?.length) {
    cacheReportTask.map((task) => beaconReport(task.eventName, task.reportObj));
  }
  cacheReportTask = [];
}
const deviceType = () => {
  let type = 'pc';
  const ua = navigator.userAgent;
  if (!isMobile()) return type;
  if (isWechat(ua)) {
    type = 'wechat';
  } else if (isWeMeetApp(ua)) {
    type = 'webview';
  } else {
    type = 'h5';
  }
  return type;
};

/**
 * 灯塔上报入口，暂时只不兼容服务端上报。
 * @param eventName 事件名称
 * @param reportObj 上报数据，注意reportObj 的value 类型只能是string 或者 number 类型
 */
export function beaconReport(eventName = '', reportObj = {}): void {
  if (isServer) {
    return;
  }
  const allCookie = cookies({});
  const hostid = sessionStorage.getItem('user:hostId') || '';
  // console.log('allCookie', allCookie);
  const userInfo: Partial<UserData> = getUserInfoFromSession() || {};
  const type = deviceType();
  const reportTask = {
    eventName,
    reportObj: {
      // chrome 调试下可能为空，取不到 http-only 的cookie
      userid: allCookie.app_uid || userInfo.userid || '-1',
      app_uid: allCookie.app_uid || userInfo.app_uid || '',
      app_id: allCookie.app_id || allCookie.corp_id || '',
      corp_type: userInfo.corp_type,
      corp_name: userInfo.corp_name,
      nick_name: userInfo.nick_name,
      device_type: type,
      platform: type,
      user_ip: atob(sessionStorage.getItem('ip') || ''),
      hostid,
      nav_platform: navigator?.platform,
      user_agent: navigator?.userAgent,
      ...reportObj,
    },
  };
  if (beaconInstance?.onDirectUserAction) {
    beaconInstance.onDirectUserAction(reportTask.eventName, reportTask.reportObj);
  } else {
    cacheReportTask.push(reportTask);
  }
}

export default beaconReport;
